export const SEARCH_RESULTS_EXPERIMENT_CONFIG = {
  name: 'numberOfResults',
  resultsCount: {
    0: 10,
    1: 30,
  },
};

export const COOKIE_SEARCH_RESULTS_EXP = 'wkda-gaexp-searchResults';
